export const initialState = () => ({
  stack: [],
});

export default initialState();
